import { useMemo } from 'react';

import { DISCOUNT_OFFER_CART_ID } from 'state/cart/constants';
import { selectors, useAppSelector } from 'state/global-state';
import { isItemOrCombo as isLegacyItemOrComboUtils } from 'utils/cart-utils';

import { countCartItems } from '../utils';

import { useMinimalCart } from './use-minimal-cart';
import { useMinimalCartUi } from './use-minimal-cart-ui';

/**
 * @deprecated use useMinimalCartItemsCount instead
 */
function countLegacyCartItems(cartEntries: Array<{ cartId?: string; quantity?: number }>) {
  return cartEntries.reduce((total, cartEntry) => {
    if (cartEntry.cartId === DISCOUNT_OFFER_CART_ID) {
      return total;
    }
    return total + (cartEntry.quantity ?? 1);
  }, 0);
}

/**
 * @deprecated use useMinimalCartItemsCount instead
 */
const useLegacyCartItemsCount = () => {
  const cartEntries = useAppSelector(selectors.ordering.selectCartEntries);
  const minimalCartEntries = useAppSelector(selectors.ordering.selectMinimalCartEntries);

  const numberOfItemsInCart = useMemo(() => {
    const itemOrComboEntries = cartEntries.filter(isLegacyItemOrComboUtils);
    return countLegacyCartItems(itemOrComboEntries) + countLegacyCartItems(minimalCartEntries);
  }, [cartEntries, minimalCartEntries]);

  return numberOfItemsInCart;
};

const useMinimalCartItemsCount = () => {
  const { cartEntries } = useMinimalCart();
  return countCartItems(cartEntries);
};

export const useCartItemsCount = () => {
  const enableMinimalCartUI = useMinimalCartUi();
  const legacyCartItemsCount = useLegacyCartItemsCount();
  const minimalCartItemsCount = useMinimalCartItemsCount();
  return enableMinimalCartUI ? minimalCartItemsCount : legacyCartItemsCount;
};
